export default __webpack_public_path__ + "static/media/helpTransChange.3a5fc6fe.png";